import { render, staticRenderFns } from "./ProvidersDialog.vue?vue&type=template&id=bee96304&scoped=true&"
import script from "./ProvidersDialog.vue?vue&type=script&lang=js&"
export * from "./ProvidersDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersDialog.vue?vue&type=style&index=0&id=bee96304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee96304",
  null
  
)

export default component.exports